<template>
  <section class="row center achievements__container">
    <div class="achievement box__shadow column center">
      <div class="header">5h</div>
      <div class="body">{{ t('achievement_1') }}</div>
    </div>

    <div class="achievement box__shadow column center">
      <div class="header">3x</div>
      <div class="body">{{ t('achievement_2') }}</div>
    </div>

    <div class="achievement box__shadow column center">
      <div class="header">10x</div>
      <div class="body">{{ t('achievement_3') }}</div>
    </div>
  </section>

  <div class="disclaimer">
    <i>{{ t('achievement_disclaimer') }}</i>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/media.scss';

.achievements__container {
  flex-wrap: wrap;
  margin: 150px auto 0 auto;
  width: 100%;
  max-width: 700px;

  @media (max-width: 599px) {
    margin-top: 100px;
  }

  .achievement {
    border-radius: 25px;
    padding: 25px;
    height: 150px;
    width: 150px;
    text-align: center;
    margin: 10px;

    @media #{$mobile} {
      width: 130px;
      height: 130px;
      margin: 5px;
      padding: 15px;
    }

    .header {
      font-size: 3.5rem;
      color: var(--arctic);

      @media #{$mobile} {
        font-size: 2.5rem;
      }
    }

    .body {
      @media #{$mobile} {
        font-size: 0.9rem;
      }
    }
  }
}

.disclaimer {
  font-size: 0.75rem;
  margin: 20px auto 0 auto;
  max-width: 500px;
  width: 90%;
  text-align: center;
  line-height: 15px;
  color: var(--dark-4);
}
</style>
